import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export function useSearchParams() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}

export function useDefaultSearchParams() {
    const searchParams = useSearchParams();

    return {
        search: searchParams.get('search') || undefined,
        page: Number(searchParams.get('page') || '1'),
        items_size: Number(searchParams.get('items_size') || '10'),
        order_by: searchParams.get('order_by') || undefined,
        order: searchParams.get('order') as ('asc' | 'desc') || undefined,
    };
}